// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// © Copyright Utrecht University (Department of Information and Computing Sciences)

import React, { useState } from 'react'
import handleLogin from '../handlers/login'
import ErrorMessage from '../../pages/data/selected_data/export_menu/components/ErrorMessage'

// Function based component rendering the login form
function LoginForm(props) {
  // State that keeps track whether the login has failed (by default false)
  const [fail, setFail] = useState(false)

  // Handler for closing the dialog
  // const closeDialog = () => {
  //   props.onClose()
  // }

  // Handler for logging in the user
  const connection = async (event) => {
    event.preventDefault()

    // Call the login handler
    const success = await handleLogin(event, props.state)

    // If login was successful, then set the username and access level in the navigation bar
    if (success) {
      let username = sessionStorage.getItem('username')
      let access_level = sessionStorage.getItem('access_level')

      props.parent.setState({
        loggedin: true,
        userName: username,
        accessLevel: access_level,
      })
      // If login failed, set fail state to true which renders the error message
    } else {
      setFail(true)
    }
  }

  // Render all the components of the login form
  return (
    <div className="med-dialog">
      <i className="bx bxs-log-in" />
      <h1>Login</h1>
      <p><strong>EMRD</strong> is currently closed to the public. Visit our <a href="https://emrd.uu.nl/info_public">public info page</a> for project details.</p>
      <form name="loginForm" onSubmit={connection}>
        <input
          type="text"
          id="username"
          className="med-credential-input med-text-input"
          placeholder="Username"
          minLength={4}
          maxLength={64}
          autoComplete="off"
          spellCheck="false"
        />
        <input
          type="password"
          id="password"
          className="med-credential-input med-text-input"
          placeholder="Password"
        />
        {/* Render error message if fail state is true */}
        {fail && (
          <ErrorMessage
            message={
              'Wrong username or password. Please check your credentials and try again.'
            }
          />
        )}
        <span className="med-description">
          <p>
            To request early access, please contact{' '}
            <a
              href={`mailto:EMRD@uu.nl?subject=Request%20for%20Early%20Access%20to%20EMRD`}
              target="_blank"
              rel="noreferrer"
            >
              {'EMRD@uu.nl'}
            </a>
            .
          </p>
        </span>
        <button
          type="submit"
          className="med-button-login med-primary-solid med-bx-button"
        >
          Sign in
        </button>
      </form>
    </div>
  )
}

export default LoginForm
